import Vue from 'vue'
import moment from 'moment'

var toFixedFix = function(n, prec) {
  var k = Math.pow(10, prec)
  return '' + parseInt(n * k) / k
}

function number_format(number, decimals, dec_point, thousands_sep, isInteger = false) {
  /*
   * 参数说明：
   * number：要格式化的数字
   * decimals：保留几位小数2
   * dec_point：小数点符号 .
   * thousands_sep：千分位符号  ,
   * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function(n, prec) {
      n = n.toString()
      // 如果存在小数点
      let k = Math.pow(10, prec)
      let index
      if (n.indexOf('.') !== -1) {
        // 拼接
        index = n.indexOf('.')
        // console.log(n.substring(0, index))
        // console.log(n.substring(index, index + 3), '12313213')
        return n.substring(0, index) + n.substring(index, index + 3)
      } else {
        // 不存在小数点，直接截取直接tofixed
        let sub = ((n * k) / k).toFixed(3)
        let res2 = sub.substring(0, sub.lastIndexOf('.') + 3)
        return res2 + ''
      }
    }
  if (isInteger) {
    s = toFixedFix(n, prec).split('.')
  } else {
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  }
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  if (isInteger) {
    return s[0]
  } else {
    return s.join(dec)
  }
}

Vue.filter('otherFilter', function(value) {
  if (value === 'other') {
    value = '其他'
  }
  return value
})

Vue.filter('NumberFormat', function(value, isInt = false, fixed = 2) {
  // isInt => 是否只保留整数部分

  // 修复：正确处理 0 和无效值
  if ((value === null || value === undefined || value === '' || isNaN(value)) && value !== 0) {
    return isInt ? '0' : '0.' + '0'.repeat(fixed)
  }

  let num = parseFloat(value)

  if (isInt) {
    // 只保留整数部分（四舍五入）
    num = Math.round(num)
    const formattedInteger = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return formattedInteger
  }

  // 非整数：先截断到指定小数位（不四舍五入）
  // 修复：支持任意 fixed 参数（原代码写死 * 100）
  const multiplier = Math.pow(10, fixed)
  num = Math.floor(num * multiplier) / multiplier

  const str = num.toFixed(fixed)
  const [integer, decimal] = str.split('.')
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return `${formattedInteger}.${decimal}`
})

Vue.filter('numberFormat', function(n, isPrefix = true, isPctfix = false) {
  if (n === null) return isPrefix ? '¥0.00' : '0.00'
  if (isPrefix) {
    return '¥' + number_format(n, 2, '.', ',')
  }
  if (isPctfix) {
    return number_format(n, 2, '.', ',') + '%'
  }
  return number_format(n, 2, '.', ',')
})

Vue.filter('date', function(value, format = 'YYYY/MM/DD') {
  if (value) {
    return moment(value).format(format)
  }
})
